<script>
import { pluck, propEq } from 'rambda'
import { mergeLabelArrays } from '@utils/collections'

export default {
  data() {
    const sorts = mergeLabelArrays([
      { $sort: { bucketIndex: 1 } },
      { $sort: { score: -1 } },
      { $sort: { valueScore: -1 } },
    ], this.$ta('sorts'))

    return {
      sortLabelActive: sorts[0].label,
      sorts,
    }
  },
  computed: {
    sortActive() {
      return this.sorts
        .find(propEq('label', this.sortLabelActive))
        .$sort
    },
    sortsLabels() {
      return pluck('label', this.sorts)
    },
  },
  render: () => '',
}
</script>
